import React from 'react';

const OpenIndicator = ({ isOpen }) => {
  const open = (
    <span
      style={{
        textTransform: 'uppercase',
        letterSpacing: 1,
        fontWeight: 'bold',
        border: '2px solid #448000',
        padding: '4px 6px',
        borderRadius: 9,
        fontFamily: 'AktivGroteskLight',
        color: '#448000'
      }}
    >
      Open
    </span>
  );

  const closed = (
    <span
      style={{
        textTransform: 'uppercase',
        letterSpacing: 1,
        fontWeight: 'bold',
        border: '2px solid #8b0000',
        padding: '4px 6px',
        borderRadius: 9,
        fontFamily: 'AktivGroteskLight',
        color: '#8b0000'
      }}
    >
      Closed
    </span>
  );
  return isOpen ? open : closed;
};

export default OpenIndicator;
